/**
 * Lưu bản ZIP bài giảng (đã giải mã từ API) trên trình duyệt (IndexedDB)
 * để trình chiếu lại không cần tải lại — không tốn thêm lượt hạn mức server.
 */

const DB_NAME = "ima_edu_lesson_assets";
const STORE = "bai_giang_zip";
const VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "documentId" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

/**
 * @param {string} documentId
 * @returns {Promise<{ documentId: string, revision: string, buffer: ArrayBuffer, savedAt: number } | null>}
 */
export async function getLessonBaiGiangZipFromDevice(documentId) {
  if (!documentId || typeof indexedDB === "undefined") return null;
  try {
    const db = await openDb();
    return await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, "readonly");
      const r = tx.objectStore(STORE).get(documentId);
      r.onsuccess = () => resolve(r.result ?? null);
      r.onerror = () => reject(r.error);
    });
  } catch {
    return null;
  }
}

/**
 * @param {string} documentId
 * @param {string} revision — khớp `last_changed` từ API (hoặc fallback)
 * @param {ArrayBuffer} arrayBuffer
 */
export async function saveLessonBaiGiangZipToDevice(documentId, revision, arrayBuffer) {
  if (!documentId || !arrayBuffer || typeof indexedDB === "undefined") return;
  const db = await openDb();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put({
      documentId,
      revision: String(revision ?? ""),
      buffer: arrayBuffer,
      savedAt: Date.now(),
    });
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}
